import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "frontend-components";
import useQuestionResponse from "../../useQuestionResponse";
import { useTranslation } from "react-i18next";

function TextResponseList() {
    const { answers, question } = useQuestionResponse();

    return (
        <div className="p-4 overflow-y-scroll grow max-h-[calc(100vh-8rem)]">
            <h2 className="text-lg pb-4 whitespace-pre-wrap">{question.questionText}</h2>
            <ul className="group">
                {answers.map((answer, idx) => (
                    <li
                        key={idx}
                        className="font-light italic max-w-full flex items-start border-b border-container-outline pb-2 last:border-0 py-4"
                    >
                        <p className="whitespace-pre-wrap">&quot;{answer.answerValue}&quot;</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default function TextResponseModal() {
    const { t } = useTranslation();
    return (
        <Dialog>
            <DialogTrigger className="underline text-sm">
                {t("responseOverview.viewAll")}
            </DialogTrigger>
            <DialogContent className=" flex flex-col">
                <DialogHeader>
                    <DialogTitle>{t("responseOverview.allResponses")}</DialogTitle>
                </DialogHeader>
                <TextResponseList />
            </DialogContent>
        </Dialog>
    );
}
